import ExtensionOption, { ExtensionOptionType } from '@/types/ExtensionOption.interface'
import Vue from 'vue'
export default Vue.extend({
    methods: {
        async extensionCreate(extension: ExtensionOption): Promise<ExtensionOption> {
            //  Prepare the extension data
            const payload = this.extensionPrep(extension)

            //  Send the POST request to the API
            const ext = await this.$store.dispatch('extensionOptionsPost', payload)

            //  If the request failed, do nothing
            if (!ext) return

            //  Else, close the app dialog
            this.$store.dispatch('dialogClose', 'APP')

            //  Return our extension
            return ext
        },
        extensionPrep(extension: ExtensionOption): ExtensionOption {
            //  Grab our current extension type and convert it to lowercase
            const currType = extension.type.toLowerCase()

            //  Convert this into our enum value
            const type = ExtensionOptionType[currType]

            //  Make sure the type is in lower case
            extension.type = type

            //  If the extension is type 'text', reset the data column
            if (type === 'text') extension.data = null

            //  Handle drop down data, convert csv to array
            if (type === 'dropdown') {
                //  Grab the data from this since it is probably a string
                const data = extension.data

                //  If the data is NOT an array then convert it to an array
                //  @ts-ignore
                if (!Array.isArray(data)) extension.data = data.split(',')
            }

            return extension
        },
        goToExtensionCreate(): void {
            //  Instantiate a new extension option
            const extension = this.$store.getters.newExtensionOption

            //  Create an app form object
            const form = {
                title: 'Create New Custom Field',
                icon: 'mdi-format-annotation-plus',
                model: extension,
                inputs: this.$store.getters.extensionOptionInputs(extension)
            }

            //  Pop an app-form
            this.$store.dispatch('dialogOpen', {
                type: 'APP',
                title: form.title,
                icon: form.icon,
                component: 'app-form',
                props: form,
                closeable: true,
                callback: (extension: ExtensionOption) => this.extensionCreate(extension)
            })
        }
    }
})